import { Paper, useTheme } from "@mui/material";
import { StrategyCreate, TimePresetType, UserState } from "../../../_app/types";
import { showNotification } from "../../../store/slices/notificationSlice";
import { setCustomGridMode } from "../../../store/slices/customBotSlice";
import { HubError } from "../../../class/Error";
import { Strategy, TimeFrame } from "../../../store/slices/strategySlice";
import { TIME_FRAME_PRESETS } from "../../../_app/consts";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { _roundDec } from "../../../utils/_roundToDecimals";
import { precision } from "../../../utils/_precision";
import { useApi } from "../../../_hooks/use-api";
import {ButtonStyled} from "../../../_components/ButtonStyled";

interface Props {
  strategy: Strategy;
  middlePrice: number;
  timeFrames: TimeFrame[];
  term: "Short" | "Mid" | "Long";
  user: UserState;
}

const AutoStrategyLaunch = ({ strategy, user, timeFrames, term, middlePrice }: Props) => {
  const theme = useTheme();
  const api = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // filtered timeFrames without key checked
  let sortedTimeFrames: TimeFrame[] = [];
  let investment = 0;
  let investmentQuote = 0;
  let requiredMargin = 0;

  if (strategy.customFrame) {
    sortedTimeFrames = timeFrames
      .filter((frame) => frame.checked)
      .map(({ checked, ...rest }) => rest);
  } else {
    sortedTimeFrames = TIME_FRAME_PRESETS[term]
      .filter((frame) => frame.checked)
      .map(({ checked, ...rest }) => rest);
  }

  if (strategy.currencyType === "BASE") {
    investment = strategy.investment;
    investmentQuote = _roundDec(
      strategy.investment * middlePrice,
      precision(strategy.ticker.orderStep)
    );
  }

  if (strategy.currencyType === "QUOTE") {
    investment = _roundDec(strategy.investment / middlePrice, precision(strategy.ticker.orderStep));
    investmentQuote = strategy.investment;
  }

  const createStrategy = async () => {
    let newStrategy: StrategyCreate | undefined = {
      base: strategy.base,
      quote: strategy.quote,
      marketType: "FUTURES_GRID",
      accountId: user.activeAccount.id,
      profileId: user.profile.profileId,
      currencyType: strategy.currencyType,
      investment: investment,
      investmentQuote: investmentQuote,
      requiredMargin: investmentQuote / strategy.leverage,
      minPrice: strategy.minPrice,
      maxPrice: strategy.maxPrice,
      leverage: strategy.leverage,
      gridDirection: strategy.gridDirection.toUpperCase(),
      timeframes: sortedTimeFrames,
      presetType: strategy.customFrame ? TimePresetType.Custom : TimePresetType[term],
      positionBehavior: strategy.positionBehaviour.toUpperCase(),
    };

    try {
      console.log(newStrategy);
      const response = await api.launchStrategy(newStrategy);
      dispatch(
        showNotification({
          message: `Auto strategy ${strategy.base}/${strategy.quote} is created`,
          severity: "success",
        })
      );
      navigate(`/bots/`);
      dispatch(setCustomGridMode(false));
      newStrategy = undefined;
    } catch (error: any) {
      const message =
        error instanceof HubError ? `${error.message} ${error.detailedMessage}` : error.message;

      dispatch(showNotification({ message, severity: "error" }));
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{ marginTop: "12px" }}
      className="base-adron-paper paper-light"
      style={{
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px -4px 6px -1px rgba(0, 0, 0, 0.10",
      }}
    >
      <ButtonStyled
        onClick={createStrategy}
        style={{ padding: "8px 16px", color: "#fff" }}
        fullWidth={true}
        color={"primary"}
        variant="contained"
      >
        Launch auto strategy
      </ButtonStyled>
    </Paper>
  );
};

export default AutoStrategyLaunch;
